<div *ngIf='sessionData' class='BillingInformation'>
  <div
    class='BillingInformation-header d-flex flex-row justify-content-between'>
    <h4 class='title__page'>Billing</h4>
    <app-button
      [color]="'blue'"
      [style]="'outline'"
      route='/messages'
      size='small'
      text='Back to Inbox'></app-button>
  </div>
  <ng-container *ngIf='!billingInfo'>
    <div class='mt-3'>
      <p class='text-muted small mb-0'>Loading billing information…</p>
    </div>
  </ng-container>
  <ng-container *ngIf='billingInfo && billingInfo.paid_by === "Manager"'>
    <div class='alert alert-warning mt-3'>
      <p>Your subscription is currently paid by your manager</p>
    </div>
  </ng-container>
  <ng-container *ngIf='billingInfo && billingInfo.paid_by !== "Manager"'>
    <div class='ChangePassword-body mt-3'>
      <div class='row'>
        <div class='col col-12 col-sm-9 offset-sm-3'>
          <div
            *ngIf='formReady'
            class='BillingInformation-form p-3 p-sm-5 d-flex flex-column'>
            <form [formGroup]='formGroup' *ngIf='formGroup' class='d-flex flex-column'>
              <div *ngIf='showPlanSelection' class='alert alert-danger mb-3'>
                <p *ngIf="sessionData.billing_status === 'Missing registration'" class='mb-0'>
                  We could not find an active subscription. Choose a plan (if required), optionally enter a
                  team/discount code, then add a payment method below and save.
                </p>
                <p *ngIf="sessionData.billing_status === 'Payment failed'" class='mb-0'>
                  The last charge failed. Choose a plan (if required), optionally enter a team/discount code, then
                  add a payment method below and save.
                </p>
                <p *ngIf="sessionData.billing_status === 'Awaiting card'" class='mb-0'>
                  Your payment method needs attention.
                  <ng-container *ngIf='sessionData.billing_grace_days_remaining != null'>
                    You have {{ sessionData.billing_grace_days_remaining }} day(s) remaining to update your card.
                  </ng-container>
                  Add or update your payment method below.
                </p>
              </div>
              <div *ngIf='hasPaymentDiscount' class='alert alert-info py-2 small mb-3'>
                {{ discountFieldNote }}
              </div>
              <div class='row mt-2'>
                <div class='col col-12'>
                  <h6 class='title__page'>Payment methods</h6>
                  <p class='text-muted small mb-2'>
                    <ng-container *ngIf='showPlanSelection; else helpReturning'>
                      <ng-container *ngIf='hasSavedPaymentMethod; else firstTimeCheckout'>
                        After choosing a plan, you can
                        <strong>subscribe with saved payment method</strong> if a default is on file, or use
                        <strong>Add another payment method</strong> to add or replace a method, then
                        <strong>Save payment details</strong>.
                      </ng-container>
                      <ng-template #firstTimeCheckout>
                        After choosing a plan, complete the
                        <strong>Card form</strong> and
                        press
                        <strong>Save payment details</strong> to subscribe.
                      </ng-template>
                    </ng-container>
                    <ng-template #helpReturning>
                      Manage cards and bank debits stored in Stripe. Add a new method with the button below, then
                      <strong>Save payment method</strong> to attach it.
                    </ng-template>
                  </p>
                  <div *ngIf='showPlanSelection' class='BillingInformation-form-row mb-3'>
                    <mat-label>Choose your plan</mat-label>
                    <app-select
                      [items]='planSelectItems'
                      formControlName='plan_id'
                      label='Select product…'></app-select>
                    <p
                      *ngIf="
                        showPlanSelection &&
                        formGroup.get('plan_id')?.invalid &&
                        formGroup.get('plan_id')?.touched
                      "
                      class='text-danger small mt-1 mb-0'>
                      Please select a plan.
                    </p>
                    <p *ngIf='!plans?.length' class='text-warning small'>No plans available. Contact support.</p>
                    <p *ngIf='hasSavedPaymentMethod' class='text-muted small mt-2 mb-0'>
                      You already have a payment method on file (e.g. bank account). You can
                      <strong>subscribe with saved payment method</strong> using your current default, or add a
                      new method in the <strong>Payment methods</strong> section above and
                      <strong>Save payment details</strong>.
                    </p>
                    <div *ngIf='hasSavedPaymentMethod' class='mt-2'>
                      <app-button
                        [Click]='subscribeWithSavedPaymentMethod'
                        [color]="'orange'"
                        [disabled]='savingWithExistingPm || peBillingSubmitting'
                        [size]="'normal'"
                        [style]="'outline'"
                        text='Subscribe with saved payment method'>
                      </app-button>
                    </div>
                  </div>
                  <div *ngIf='!hasPaymentDiscount' class='BillingInformation-discount mb-3'>
                    <mat-accordion>
                      <mat-expansion-panel [expanded]='false' class='BillingInformation-discount-panel'>
                        <mat-expansion-panel-header class='BillingInformation-discount-header'>
                          <mat-panel-title class='BillingInformation-discount-title'>
                            <span class='BillingInformation-discount-icon' aria-hidden='true'>
                              <app-svg-renderer [svg]="'Contacts Icon'"></app-svg-renderer>
                            </span>
                            <span class='BillingInformation-discount-label'>Apply Team or Discount Code</span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class='BillingInformation-discount-body'>
                          <app-text-field
                            formControlName='team_code'
                            placeholder='Team or discount code'></app-text-field>
                          <p *ngIf='showPlanSelection' class='text-muted small mt-2 mb-0'>
                            This code is sent when you use <strong>Save payment details</strong> below (or
                            <strong>Subscribe with saved payment method</strong>). Invalid codes are rejected by the
                            server.
                          </p>
                          <p *ngIf='!showPlanSelection && canApplyDiscountOnly' class='text-muted small mt-2 mb-0'>
                            For an active subscription you can apply a code with
                            <strong>Apply team / discount code</strong> only, or include it when you add a new payment
                            method and use Save there.
                          </p>
                          <p *ngIf='!showPlanSelection && !canApplyDiscountOnly' class='text-muted small mt-2 mb-0'>
                            Use with <strong>Save payment method</strong> when you add or change a payment method below.
                          </p>
                          <div *ngIf='canApplyDiscountOnly' class='mt-2'>
                            <app-button
                              [Click]='applyDiscountCodeOnly'
                              [color]="'orange'"
                              [disabled]='applyingDiscountOnly'
                              [size]="'normal'"
                              [style]="'outline'"
                              text='Apply team / discount code'>
                            </app-button>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                  <div
                    *ngIf='paymentElementAutoLoading'
                    class='d-flex align-items-center my-2'>
                    <mat-spinner [diameter]='36' class='mr-3'></mat-spinner>
                    <span class='text-muted small mb-0'>Loading payment form…</span>
                  </div>
                  <ng-container *ngIf='stripePaymentMethods?.items?.length; else noPm'>
                    <ul class='list-group mb-3'>
                      <li
                        *ngFor='let item of stripePaymentMethods.items'
                        class='list-group-item d-flex justify-content-between align-items-center flex-wrap'>
                        <div>
                          <span *ngIf='item.is_default' class='badge badge-success mr-2'>Default</span>
                          <span>{{ formatPmLabel(item) }}</span>
                        </div>
                        <app-button
                          (clicked)='setDefaultPaymentMethod(item.id)'
                          *ngIf='!item.is_default'
                          [disabled]='settingDefaultPm !== null'
                          [style]="'outline'"
                          color='blue'
                          [text]="'Set as default'"
                          size='small'></app-button>
                      </li>
                    </ul>
                  </ng-container>
                  <ng-template #noPm></ng-template>
                  <app-button
                    *ngIf='!showPlanSelection || hasSavedPaymentMethod'
                    [Click]='openPaymentElementManually'
                    [style]="'outline'"
                    color='blue'
                    size='normal'
                    [text]='addPaymentMethodButtonLabel'>
                  </app-button>
                </div>
              </div>
              <div *ngIf='peBillingReady' class='mt-3'>
                <p class='text-muted small mb-2'>Enter your details in the secure Card form, then save.</p>
                <div #peBillingHost class='billing-stripe-embed-host'></div>
                <app-button
                  [Click]='confirmBillingPaymentElement'
                  [color]="'orange'"
                  [disabled]='peBillingSubmitting'
                  [size]="'normal'"
                  [style]="'rounded'"
                  class='mt-2'
                  [text]="showPlanSelection ? 'Save payment details' : 'Save payment method'">
                </app-button>
              </div>
              <div
                *ngIf="
                  sessionData.billing_status &&
                  sessionData.billing_status !== 'Active' &&
                  !showPlanSelection
                "
                class='mt-1 mb-3'
                [ngClass]="sessionData.billing_status === 'Awaiting card' ? 'alert alert-warning' : 'alert alert-danger'">
                <ng-container [ngSwitch]='sessionData.billing_status'>
                  <p *ngSwitchCase="'Expired'" class='mb-0'>
                    Your card has expired. Please add a new payment method below.
                  </p>
                  <p *ngSwitchCase="'Payment failed'" class='mb-0'>
                    The last charge failed. Please add or update your payment method below.
                  </p>
                  <p *ngSwitchCase="'Awaiting card'" class='mb-0'>
                    Your payment method needs attention.
                    <ng-container *ngIf='sessionData.billing_grace_days_remaining != null'>
                      You have {{ sessionData.billing_grace_days_remaining }} day(s) remaining before access is restricted.
                    </ng-container>
                    Please add or update your payment method below.
                  </p>
                  <p *ngSwitchCase="'Missing registration'" class='mb-0'>
                    We could not find an active subscription. Choose a plan (if required), optionally enter a
                    team/discount
                    code, then add a payment method below and save.
                  </p>
                  <p *ngSwitchDefault class='mb-0'>Please update your billing information below.</p>
                </ng-container>
              </div>
              <div class='row BillingInformation-form-row mt-4'>
                <div class='col d-flex'>
                  <app-button
                    [color]='cancelButtonProperties.color'
                    [route]='cancelButtonProperties.route'
                    [size]='cancelButtonProperties.size'
                    [style]='cancelButtonProperties.style'
                    [text]='cancelButtonProperties.text'
                    class='BillingInformation-form-button'></app-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
